import { NavIcon } from "./nav-icons.js"

/**
 * The link to the Ternary docs, for a page header's actions: a kit icon button as a link. The icon
 * is decorative; the visually hidden text names it.
 */
export function DocsLink() {
  return (
    <a
      className="tny-button tny-button-secondary tny-icon-button"
      href="https://docs.ternarydev.com/"
      rel="noreferrer"
      target="_blank"
      title="Documentation"
    >
      <span aria-hidden="true" className="tny-button-icon">
        <NavIcon name="help" />
      </span>
      <span className="tny-visually-hidden">Documentation</span>
    </a>
  )
}
